import { BehaviorSubject, Observable } from 'rxjs';
import { LoginModel } from '@core/model/login.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
// import { LoginRespuestaModel } from '@core/model/login.respuesta.model';
import { utiles } from '@utl/environment';
import { Injectable } from "@angular/core";

const methodAuthenticationApi = 'api/Token/Token';
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class AuthenticationService {

    // private currentUserSecurity: BehaviorSubject<LoginRespuestaModel>;
    // public currentSecurity: Observable<LoginRespuestaModel>;
    private currentUserLocal: BehaviorSubject<LoginModel>;
    public currentUser: Observable<LoginModel>;

    constructor(private http: HttpClient) {
        // this.currentUserLocal = new BehaviorSubject<LoginModel>(utiles.getInfoAuthorization());
        // this.currentUser = this.currentUserLocal.asObservable();
        // this.currentUserSecurity = new BehaviorSubject<LoginRespuestaModel>(utiles.obtenerInfoUsuario());
        // this.currentSecurity = this.currentUserSecurity.asObservable();
    }

}

